import { Compass } from "lucide-react";
import { cn } from "@/lib/utils";

export const ComingSoonCard = ({ className }: { className?: string }) => {
    return (
        <div className={cn(
            "rounded-2xl border-2 border-dashed border-primary-200 bg-primary-50/50 p-8 flex flex-col items-center justify-center text-center min-h-100",
            className
        )}>
            <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center mb-6 shadow-sm shadow-primary-100">
                <Compass className="w-8 h-8 text-primary-500 animate-pulse" />
            </div>
            
            <h3 className="font-brastika text-3xl text-primary-900 mb-4">Bientôt</h3>
            
            <p className="text-primary-600 max-w-50 text-sm leading-relaxed">
                Nouveaux écrins en préparation à Constantine et Tlemcen.
            </p>
            
            <div className="flex gap-1.5 mt-6">
                <span className="w-1.5 h-1.5 rounded-full bg-primary-300"></span>
                <span className="w-1.5 h-1.5 rounded-full bg-primary-300"></span>
                <span className="w-1.5 h-1.5 rounded-full bg-primary-300"></span>
            </div>
        </div>
    );
};
